var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 23.3333H5.83333V8.16667L14 0L15.4583 1.45833C15.5944 1.59444 15.7063 1.77917 15.7938 2.0125C15.8813 2.24583 15.925 2.46944 15.925 2.68333V3.09167L14.6417 8.16667H22.1667C22.7889 8.16667 23.3333 8.4 23.8 8.86667C24.2667 9.33333 24.5 9.87778 24.5 10.5V12.8333C24.5 12.9694 24.4806 13.1153 24.4417 13.2708C24.4028 13.4264 24.3639 13.5722 24.325 13.7083L20.825 21.9333C20.65 22.3222 20.3583 22.6528 19.95 22.925C19.5417 23.1972 19.1139 23.3333 18.6667 23.3333ZM8.16667 21H18.6667L22.1667 12.8333V10.5H11.6667L13.2417 4.08333L8.16667 9.15833V21ZM5.83333 8.16667V10.5H2.33333V21H5.83333V23.3333H0V8.16667H5.83333Z",
    fill: "#0080A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpBlue);
export default __webpack_public_path__ + "static/media/thumbsUpBlue.a1d46ff2c2090c1b7de6260a60cf8b4b.svg";
export { ForwardRef as ReactComponent };